import { render, staticRenderFns } from "./SellOffers.vue?vue&type=template&id=37f06d88"
import script from "./SellOffers.vue?vue&type=script&lang=js"
export * from "./SellOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports